import { X, HelpCircle } from 'lucide-react';
import { getStepHelp } from '../../lib/journeyStepHelp';

interface Props {
  stepKey: string;
  title: string;
  description?: string | null;
  onClose: () => void;
}

export function StepHelpModal({ stepKey, title, description, onClose }: Props) {
  const help = getStepHelp(stepKey, description);
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <h2 className="text-base font-semibold flex items-center gap-2">
            <HelpCircle className="w-4 h-4 text-teal-600" /> {title}
          </h2>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-5 space-y-4 text-sm">
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Wat doet deze stap?</div>
            <p className="text-slate-700 leading-relaxed">{help.wat}</p>
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Wanneer gebeurt het?</div>
            <p className="text-slate-700 leading-relaxed">{help.wanneer}</p>
          </div>
          <div className="text-[11px] text-slate-400 font-mono pt-2 border-t border-slate-100">{stepKey}</div>
        </div>
      </div>
    </div>
  );
}
